// extracted by mini-css-extract-plugin
export default {"container":"Migrate_container__b-UZH","min_container":"Migrate_min_container__c8J3C"};